/**
 * API utilities
 *
 * Helpers for working with API responses.
 */

/**
 * Extracts a human-readable error message from a fetch Response.
 * Falls back to the provided message when the response body can't be parsed.
 */
export const extractApiErrorMessage = async (response: Response, fallback: string): Promise<string> => {
  try {
    const data = await response.clone().json();
    if (data && typeof data === 'object') {
      if (typeof data.message === 'string' && data.message.trim().length > 0) {
        return data.message;
      }
      if (typeof (data as { error?: string }).error === 'string' && (data as { error?: string }).error?.trim()) {
        return (data as { error: string }).error;
      }
    }
  } catch {
    try {
      const text = await response.clone().text();
      if (text.trim().length > 0) {
        return text;
      }
    } catch {
      // Ignore parsing errors and fall back to the default message.
    }
  }

  return fallback;
};
